export function RenderModeGlyph() {
  return (
    <svg
      className="render-mode-glyph"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <text
        x="8"
        y="8.1"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="KaTeX_Main, Times New Roman, serif"
        fontSize="12.5"
        fontWeight="500"
        fill="currentColor"
      >
        Σ
      </text>
    </svg>
  );
}
